/**
 * The Core remains the authority for detecting an overwrite. This helper
 * recognizes only its explicit, user-safe conflict response so the Web never
 * treats an arbitrary 409 as permission to retry with confirmation.
 */
export function requiresCopilotReplacementConfirmation(message: string): boolean {
  return /esta proposta substituirá uma informação já salva/i.test(message);
}
